module.exports = __webpack_public_path__ + "img/q5-opt-c.8db74a82.png";